module.exports = __webpack_public_path__ + "img/claywall64_ua.68e58366.webp";